import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ToastState {
  message: string | null;
  severity: 'success' | 'error' | 'warn' | 'info';
  duration?: number;
  header?: string | null;
  subHeader?: string | null;
}

const initialState: ToastState = {
  message: null,
  severity: 'info',
  duration: 10000,
  header: null,
  subHeader: null,
};


const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    setToast: (state, action: PayloadAction<{ message: string; severity: 'success' | 'error' | 'warn' | 'info'; duration?: number; header?: string; subHeader?: string }>) => {
      state.message = action.payload.message;
      state.severity = action.payload.severity;
      state.duration = action.payload.duration || 10000;
      state.header = action.payload.header || null;
      state.subHeader = action.payload.subHeader || null;
    },
    clearToast: (state) => {
      state.message = null;
      state.severity = 'info';
      state.duration = 3000;
      state.header = null;
      state.subHeader = null;
    },
  },
});

export const { setToast, clearToast } = toastSlice.actions;
export default toastSlice.reducer;